import { render, staticRenderFns } from "./DropdownInput.vue?vue&type=template&id=5183fc9e&"
import script from "./DropdownInput.vue?vue&type=script&lang=ts&"
export * from "./DropdownInput.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownInput.vue?vue&type=style&index=0&id=5183fc9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports